import ApolloClient from 'apollo-client';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { createHttpLink } from 'apollo-link-http';
import { setContext } from 'apollo-link-context';
import gql from 'graphql-tag';
import { getToken } from 'store/authentication/session';

const authLink = setContext((_, { headers }) => ({
  headers: {
    ...headers,
    authorization: `Bearer ${getToken()}`,
  },
}));

const watchApiClient = new ApolloClient({
  link: authLink.concat(createHttpLink({ uri: 'https://api.watch.apps.productplacement.com/graphql' })),
  cache: new InMemoryCache(),
  defaultOptions: {
    watchQuery: {
      fetchPolicy: 'network-only', // Disable caching by default
    },
    query: {
      fetchPolicy: 'network-only',
    },
  },
});

export const GET_VIEWERSHIPS = gql`
  query GetViewershipsBySource($sourceId: Int!) {
    viewerships(sourceId: $sourceId) {
      id
      type
      notes
      premiereDate
      provider
      premiereImpressions
      past30Impressions
      past60Impressions
      past90Impressions
      past365Impressions
      healthMetadata {
        reportingWindow
        state
        expectedAvailableAt
      }
      station {
        id
        displayName
        country
        image
      }
      premiereDetails {
        ...ViewershipDetail
      }
      past30Details {
        ...ViewershipDetail
      }
      past60Details {
        ...ViewershipDetail
      }
      past90Details {
        ...ViewershipDetail
      }
      past365Details {
        ...ViewershipDetail
      }
    }
  }

  fragment ViewershipDetail on ViewershipDetailDTO {
    airingIds
    male
    female
    age_1_17
    age_18_24
    age_25_34
    age_35_44
    age_45_54
    age_55_65
    age_65_plus
    age_21_plus
    ethnicity_white
    ethnicity_hispanic
    ethnicity_black
    ethnicity_asian
    ethnicity_other
    income_under_20
    income_under_50
    income_20_49
    income_50_74
    income_75_99
    income_100_149
    income_150_199
    income_100_plus
    income_200_plus
    extraData
    description
  }
`;

export { watchApiClient };
